import { createContext } from 'react';

export type PushToCardCtx = {
  showPushToCardSuccessAlert: boolean;
  showPushToCardErrorAlert: boolean;
  pushToCardError: string;
};

const PushToCardContext = createContext<PushToCardCtx>({
  showPushToCardSuccessAlert: false,
  showPushToCardErrorAlert: false,
  pushToCardError: '',
});

export default PushToCardContext;
